import React from 'react'
import { useSelector } from 'react-redux'
import LoaderCircle from '@/components/LoaderCircle'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'

import s from './styles.module.scss'

const StatCard = ({ title, children }) => {
  const { isLoading } = useSelector((state) => state.statistics)
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        '& > :not(style)': {
          m: 1,

          minHeight: 250,
          padding: 2,
        },
      }}
    >
      <Paper elevation={3} className={s.paper}>
        {isLoading ? (
          <LoaderCircle />
        ) : (
          <>
            <div className={s.title}>{title}</div>
            <div>{children}</div>
          </>
        )}
      </Paper>
    </Box>
  )
}

export default StatCard
